var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../../interface/IVueDialog";
import CategoryService from "../../../api/CategoryService";
import GoodService from "../../../api/GoodService";
import { Loading } from 'element-ui';
var AddDialog = (function (_super) {
    __extends(AddDialog, _super);
    function AddDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = {
            goods_type_pinyin: '',
            goods_type_code: '',
            goods_type_icon_id: ''
        };
        _this.categoryData = [];
        _this.categoryIconList = [];
        _this.showIcon = false;
        _this.regular = {
            goods_type_code: /[\u4E00-\u9FA5]+/g
        };
        _this.limit = 1;
        _this.maxSize = 2;
        return _this;
    }
    AddDialog.prototype.created = function () {
        this.service = CategoryService.getInstance();
        this.goodService = GoodService.getInstance();
        this.getCategory();
        this.getCategoryIconList();
        if (this.category) {
            this.formData = __assign({}, this.formData, this.category);
            if (this.formData && this.formData.parent_name == '全部')
                this.showIcon = true;
            this.isEdit = true;
        }
    };
    AddDialog.prototype.mounted = function () {
        this.user = this.user;
    };
    AddDialog.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    AddDialog.prototype.getPinyin = function (e) {
        var _this = this;
        var value = e.target.value;
        if (value) {
            this.goodService.getPinyin({ name: value }).then(function (res) {
                _this.formData.goods_type_pinyin = res.data.data.pinyin;
            });
        }
        else {
            this.formData.goods_type_pinyin = '';
        }
    };
    AddDialog.prototype.getCategory = function () {
        var _this = this;
        this.service.getCategoryTree().then(function (res) {
            if (res.data.success) {
                _this.categoryData = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    AddDialog.prototype.getCategoryIconList = function (iconId) {
        var _this = this;
        if (iconId === void 0) { iconId = ''; }
        this.service.getCategoryIconList().then(function (res) {
            _this.categoryIconList = res.data.data;
            if (_this.categoryIconList && _this.categoryIconList.length > 0) {
                if (iconId) {
                    _this.formData.goods_type_icon_id = iconId;
                }
                else {
                    _this.formData.goods_type_icon_id = _this.categoryIconList[0].goods_type_icon_id;
                }
                console.info('this.category', _this.category);
                if (_this.category && _this.category.goods_type_icon_id)
                    _this.formData.goods_type_icon_id = _this.category.goods_type_icon_id;
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    AddDialog.prototype.checkInput = function (e, key, length) {
        if (key == "goods_type_name") {
            var value = e.currentTarget.value;
            if (this.getByteLen(value) > length) {
                value = this.getByteVal(value, length);
                ;
            }
            this.formData[key] = value;
        }
        else {
            var value = e.currentTarget.value;
            value = value.replace(this.regular[key], '');
            this.formData[key] = value.length > length ? value.slice(0, length) : value;
        }
    };
    AddDialog.prototype.getByteVal = function (val, max) {
        var returnValue = '';
        var byteValLen = 0;
        for (var i = 0; i < val.length; i++) {
            if (val[i].match(/[^\x00-\xff]/ig) != null) {
                byteValLen += 2;
            }
            else {
                byteValLen += 1;
            }
            if (byteValLen > max) {
                break;
            }
            returnValue += val[i];
        }
        return returnValue;
    };
    AddDialog.prototype.getByteLen = function (val) {
        var len = 0;
        for (var i = 0; i < val.length; i++) {
            if (val[i].match(/[^\x00-\xff]/ig) != null) {
                len += 2;
            }
            else {
                len += 1;
            }
        }
        return Math.floor(len);
    };
    AddDialog.prototype.close = function () {
        this.$closeDialog();
    };
    AddDialog.prototype.checkParams = function () {
        if (this.isEdit && !this.formData.goods_type_id)
            return '请选择货品类别';
        if (!this.formData.goods_type_name)
            return '请输入类别名称';
        if (!this.formData.goods_type_code)
            return '请输入类别编码';
        if (this.formData.sort && this.formData.sort <= 0)
            return '请输入大于0的整数';
        if (this.formData.parent_id && this.showIcon && !this.formData.goods_type_icon_id)
            return '请选择货品类别图标';
        return '';
    };
    AddDialog.prototype.handleTooltipMouseEnter = function (goodsTypeIconId) {
        this.enterGoodsTypeIconId = goodsTypeIconId;
        this.$forceUpdate();
    };
    AddDialog.prototype.handleTooltipMouseLeave = function (goodsTypeIconId) {
        this.enterGoodsTypeIconId = goodsTypeIconId;
        this.$forceUpdate();
    };
    AddDialog.prototype.handleDeleteIcon = function (goodsTypeIconId, index) {
        var _this = this;
        var params = {
            goods_type_icon_id: goodsTypeIconId
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.deleteIcon(params).then(function (res) {
            loadingInstance.close();
            if (res.data.success) {
                _this.categoryIconList.splice(index, 1);
                _this.$message.success(res.data.msg);
                window._czc.push(["_trackEvent", '货品类别列表', '删除图标']);
            }
            else {
                _this.$message.error(res.data.msg);
            }
        });
    };
    AddDialog.prototype.saveData = function () {
        var _this = this;
        var checkResult = this.checkParams();
        if (checkResult) {
            this.$message.error(checkResult);
            return;
        }
        var params = {
            goods_type_id: this.formData.goods_type_id,
            parent_id: this.formData.parent_id,
            goods_type_name: this.formData.goods_type_name,
            goods_type_pinyin: this.formData.goods_type_pinyin,
            goods_type_code: this.formData.goods_type_code,
            goods_type_icon_id: this.formData.goods_type_icon_id,
            sort: this.formData.sort || undefined
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service[this.isEdit ? 'edit' : 'save'](params).then(function (res) {
            loadingInstance.close();
            if (res.data.success) {
                _this.$message.success(res.data.msg);
                _this.close();
                _this.$emit('freshCategory');
                if (_this.isEdit) {
                    window._czc.push(["_trackEvent", '货品类别列表', '编辑类别']);
                }
                else {
                    window._czc.push(["_trackEvent", '货品类别列表', '新增类别']);
                }
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    AddDialog.prototype.updateParentId = function (parentNode) {
        if (parentNode && parentNode.label == '全部') {
            this.showIcon = true;
        }
        else {
            this.showIcon = false;
        }
    };
    AddDialog.prototype.beforeUpload = function (file) {
        if (this.categoryIconList.length >= 40) {
            this.$message({
                showClose: true,
                message: "类别图标总数不能超过40个",
                type: 'error'
            });
            return false;
        }
        var isLtMaxSize = file.size / 1024 / 1024 < this.maxSize;
        if (!isLtMaxSize) {
            this.$message({
                showClose: true,
                message: "单张图片不能超过 " + this.maxSize + "MB!",
                type: 'error'
            });
            return false;
        }
    };
    AddDialog.prototype.uploadSuccess = function (response, file, fileList) {
        var _this = this;
        if (file && file.response && file.response.data && file.response.data.full_path) {
            var defaultObj = {
                url: file.response.data.full_path
            };
            this.service.creatIcon(defaultObj).then(function (res) {
                if (res.data && res.data.success) {
                    var iconId = '';
                    if (res.data.data)
                        iconId = res.data.data.goods_type_icon_id;
                    _this.getCategoryIconList(iconId);
                    if (_this.$refs.upload) {
                        _this.$refs.upload.clearFiles();
                    }
                }
                else {
                    _this.$message.error(res.data.msg);
                }
            }, function (err) {
                _this.$message.error(err.message || err.msg);
            }).catch(function (err) {
                _this.$message.error(err.message);
            });
        }
    };
    AddDialog = __decorate([
        Component
    ], AddDialog);
    return AddDialog;
}(VueDialog));
export default AddDialog;
